var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#77928B",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.765 1.647c1.59 0 4.117 1.153 4.117 4.241 0 1.78-1.416 3.846-4.117 6.028C3.064 9.734 1.647 7.66 1.647 5.888c0-3.088 2.528-4.24 4.118-4.24m0-1.648C3.072 0 0 2.026 0 5.888c0 2.57 1.919 5.28 5.765 8.112 3.846-2.833 5.764-5.542 5.764-8.112C11.53 2.026 8.458 0 5.765 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.765 4.118c-.906 0-1.647.74-1.647 1.647a1.647 1.647 0 1 0 1.647-1.647z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinIcon);
export default __webpack_public_path__ + "static/media/pin-icon.5522ad0cba0d1494de62ad495c27e0d7.svg";
export { ForwardRef as ReactComponent };